/** Created by azhou on 2019/3/15.*/
<template>
  <div>
    <public-title>消息列表
       <el-button slot="right" class="titke-bttom " @click="markAllRead" type="primary" size="mini">全部标记已读</el-button>
      <!-- <span slot="right"  ></span> -->
    </public-title>
    <div class="load-area">
      <el-tabs v-model="activeName">
        <el-tab-pane name="2">
          <label slot="label">订单消息
            <!-- <span class="unread-msg" v-if="unReadTrade>0">{{unReadTrade}}</span> -->
          </label>
        </el-tab-pane>
        <el-tab-pane name="1">
          <label slot="label">系统消息
            <!-- <span class="unread-msg" v-if="unReadSys>0">{{unReadSys}}</span> -->
          </label>
        </el-tab-pane>
      </el-tabs>
      <p v-if="msgLists.total<=0" class="mt-4">当前没有数据</p>
      <div class="mt-4" v-else>
        <div class="d-start-center border-bottom pt-2 pb-2 cursor-pointer"
             @click="goForDetail(item.id)"
             v-for="item in msgLists.lists" :key="item.id">
          <i class="iconfont icon-yuandianxiao" :class="[item.is_read==1 ? 'text-white' : 'text-danger']"></i>
          {{item.title | formatString(50)}}
          <span class="ml-auto">{{item.add_time | formatTimestamp(1)}}</span>
        </div>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="msgLists.total" :current-page="Number(queryCon.page)"
                       @current-change="v => this.currentPage=v"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'MsgLists',
    computed: {
      ...mapState(['msgLists','unReadTrade','unReadSys']),
      queryCon () {
        return this.$route.query
      },
    },
    watch: {
      queryCon () {
        this.activeName = this.queryCon.msg_type
        this.getMsgList({ ...this.queryCon, page: this.currentPage })
      },
      currentPage () {
        this.$router.push({
          name: this.$route.name,
          query: {
            ...this.queryCon,
            page: this.currentPage,
            msg_type:this.activeName
          }
        })
      },
      activeName (newVal) {
        if (this.currentPage !== 1) this.currentPage = 1;
        else this.$router.push({
          name: this.$route.name,
          query: {
            ...this.queryCon,
            msg_type:newVal
          }
        })
      }
    },
    data () {
      return {
        activeName: '2',
        currentPage: 1
      }
    },
    created () {
      this.activeName = this.queryCon.msg_type;
      this.getMsgList({
        msg_type: this.activeName,
        page: this.currentPage
      })
    },
    methods: {
      ...mapActions(['getMsgList', 'readMsg']),
      goForDetail (id) {
        this.$router.push({ name: 'MsgDetail', query: { id } })
      },
      /*全部标记已读*/
      markAllRead () {
        this.readMsg({
          msg_type: this.activeName,
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .unread-msg{
    top: 0;
    left: 58px;
  }
  .titke-bttom{
    margin-left: auto;
  }
</style>
